// utils/scriptCache.js
import mainApi from "./api";

let cachedScript = null;

export function preloadScript() {
  if (cachedScript) return;

  mainApi
    .getScript("premiere-pro.jsxbin") // ← название файла можно изменить при необходимости
    .then((script) => {
      cachedScript = script;
    })
    .catch((err) => {
      alert("Ошибка загрузки скрипта:", err);
    });
}

export function getCachedScript() {
  if (cachedScript) {
    window.jsx.evalScript(cachedScript);
    return true;
  }
  return false;
}
